/**
 * 进度条组件
 * 显示任务处理进度
 */
import React from 'react';
import { Card, Progress, Space, Spin, Typography } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const { Text } = Typography;

const ProgressBar = ({ progress, message, status }) => {
  const isProcessing = status === 'processing';
  const progressStatus = isProcessing ? 'active' : 'success';

  return (
    <Card
      title={
        <Space>
          <span className="step-number">3</span>
          <span>处理进度</span>
        </Space>
      }
      style={{ marginBottom: 24 }}
    >
      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        <Progress
          percent={progress}
          status={progressStatus}
          strokeColor={{
            '0%': '#108ee9',
            '100%': '#87d068',
          }}
        />

        <div style={{ textAlign: 'center' }}>
          {isProcessing && (
            <Spin
              indicator={<LoadingOutlined style={{ fontSize: 32 }} spin />}
              style={{ marginBottom: 16 }}
            />
          )}
          <Text type="secondary" style={{ fontSize: 16 }}>
            {message || '正在处理...'}
          </Text>
        </div>
      </Space>
    </Card>
  );
};

export default ProgressBar;

